import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import type {
  InternalTrackSelectionData,
  InternalTrackSelectionTestResult,
  InternalTrackSelection,
  TrackSelectionVariant,
} from "@/monarch/rules/trackSelection/types";

const CUSTOM_RULE_ID = "internalTrackSelect";

const useInternalTrackSelect: InternalTrackSelection = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: InternalTrackSelectionData;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as InternalTrackSelectionTestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant: value.data.useInternalTrackSelection,
    data: value.data,
  };
};

export default useInternalTrackSelect;
